import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { minTouchTargetPx } from '../../tokens/spacing.js';
export const Select = React.forwardRef(function Select({ className, style, children, ...rest }, ref) {
    return (_jsx("select", { ref: ref, className: className, "data-select": true, style: {
            display: 'block',
            width: '100%',
            minHeight: `${minTouchTargetPx}px`,
            padding: `var(--space-2) var(--space-3)`,
            borderRadius: 'var(--radius-input)',
            border: '1px solid var(--text-dim)',
            background: 'var(--surface)',
            color: 'var(--text)',
            fontFamily: 'var(--font-ui)',
            fontSize: 'var(--font-size-2xs)',
            outlineColor: 'var(--focus-ring)',
            ...style,
        }, ...rest, children: children }));
});
//# sourceMappingURL=Select.js.map